import axios from 'axios';
import store from "@/store";
import router from "@/routes";

export const HTTP = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    withCredentials: false,
    headers: {
        'Content-Type': "application/json",
        'Accept': "application/json",
        'X-Requested-With': "XMLHttpRequest",
        'Access-Control-Allow-Origin': "*",
    },
})

// Injecte le token à CHAQUE requête (au lieu de figer la valeur au boot)
HTTP.interceptors.request.use(function (config) {
    const token = store && store.state && store.state.user ? store.state.user.token : null;
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
});

HTTP.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error && error.response && error.response.status === 401) {
        store.dispatch('user', '').then().catch()
        store.dispatch('isLoggedIn', false).then().catch()
        store.dispatch('permissions', []).then().catch()
        if (router.currentRoute.name !== 'login') {
            window.location.href = '/login'
        }
    }
    return Promise.reject(error)
})